import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Pagination } from "../../../Components/Pagination";
import { faRetweet } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ShipTable from "../components/ShipTable";
import EditModal from "../components/EditModal";
import ShipModal from "../components/ShipModal";
import moment from "moment";

export default function ShipConfirm() {
  const { proxy, lang, auth } = useSelector((s) => s);
  const navigate = useNavigate();
  const token = localStorage.getItem("_token");

  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const [dataCheckbox, setDataCheckbox] = useState([]);
  const [selectedForEdit, setSelectedForEdit] = useState(null);
  const [selectedForShip, setSelectedForShip] = useState(null);
  const [dataShipModal, setDataShipModal] = useState(null);

  const dataPerPage = 10;
  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const [search, setSearch] = useState({
    page: 1,
    limit: dataPerPage,
    "10MPXK": "",
    maPhieuXuatKhoERP: "",
    lenhXuatHangERP: "",
    "1BSPT": "",
    "2ĐDBX": "",
    "10NN": "",
    lyDoXuatPXK: "",
    trangthaichuyen: "",
    flag: "",
    "136NT": "",
    nguonDongBoPXK: "",
  });
  const [searchDraft, setSearchDraft] = useState();

  useEffect(() => {
    if (!searchDraft) return;
    const timer = setTimeout(() => {
      setCurrentPage(1);
      setSearch((prev) => ({
        ...prev,
        ...searchDraft,
        page: 1,
        limit: dataPerPage,
      }));
    }, 500);
    return () => clearTimeout(timer);
  }, [searchDraft]);

  const headers = useMemo(() => [
    { label: "Phiếu Xuất Kho", displayFields: "10MPXK" },
    { label: "Phiếu Xuất Kho ERP", displayFields: "maPhieuXuatKhoERP" },
    { label: "LXH/LĐĐNB", displayFields: "LXH" },
    { label: "Phân Phối Từ Kho", displayFields: "ppTuKho" },
    { label: "Ngày Xuất", displayFields: "ngayXuat", isDate: true },
    { label: "Kho Đến", displayFields: "khoden" },
    { label: "Đơn Vị Phân Phối Đến", displayFields: "donViPhanPhoi" },
    { label: "SL Cần Xuất", displayFields: "SLT" },
    { label: "SL Ghi Nhận", displayFields: "slGhiNhan" },
    { label: "SL Gán Thất Bại LPP", displayFields: "SLGTBPP" },
    { label: "SL Gán Thất Bại PXK", displayFields: "SLGTBPXK" },
    {
      label: "Phương Tiện",
      displayFields: ["phuongTien", "STTxe", "bsXeGhe"],
    },
    { label: "Đại Diện Bốc Xếp", displayFields: "daiDienBocXep" },
    { label: "Người Nhận", displayFields: "nguoiNhan" },
    { label: "Ngày Lập Phiếu", displayFields: "ngayLapPhieu", isDate: true },
    { label: "Lý Do Xuất", displayFields: "lyDoXuat" },
    { label: "SL Ghi Nhận", displayFields: "SLGN" },
    { label: "Trạng Thái Chuyến", displayFields: "trangthaichuyen" },
    { label: "Flag", displayFields: "flag" },
    { label: "Người Tạo Phiếu", displayFields: ["MaNT", "nguoiTaoPhieu"] },
    { label: "Nguồn Đồng Bộ", displayFields: "nguonDongBoPXK" },
    { label: "Trạng Thái", displayFields: "TrangThai" },
  ]);

  useEffect(() => {
    setLoading(true);
    const body = { ...search, page: currentPage, limit: dataPerPage };

    fetch(proxy() + `/api/PXK/ShipConfirmPhieuXuatKho`, {
      method: "POST",
      headers: { Authorization: token, "content-type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((res) => {
        const { data = [], total = 0 } = res || {};
        const mappedData = data.map((item) => {
          const { dataLogsPXKXN = [] } = item?.shipHang || {};

          return {
            ...item,
            dataShips: {
              _id:
                !dataLogsPXKXN || dataLogsPXKXN.length === 0
                  ? item?.soanHang?.idLogsPXK
                  : item?.soanHang.idLogsPXKXN,
              maphieuxuatkho: item?.maPhieuXuatKhoERP,
              ngayxuat: item?.shipHang?.ngayxuat
                ? item?.shipHang?.ngayxuat
                : item?.soanHang?.ngayxuat,
              sttxetau: item?.dataPXK?.sttxetau,
              chuxetau: item?.dataPXK?.chuxetau,
              daidienbocxep: item?.dataPXK?.daidienbocxep,
              tenphuongtien: item?.dataPXK?.tenphuongtien,
              // daidienbocxep: item?.dataPXK?.daidienbocxep,
              nguoinhan: item?.dataPXK?.nguoinhan,
              biensoxetau: item?.dataPXK?.biensoxetau,
              // chuxetau: item?.dataPXK?.chuxetau,
              lenhxuathang: item?.dataPXK?.lenhxuathang,
              username: auth?.username,
              user_name: auth?.username,
              phieuxuatkhosaas: item?.dataPXK?.phieuxuatkhosaas,
              giayuyquyen: item?.shipHang?.giayuyquyen,
              ngaydangky: item?.shipHang?.ngaydangky,
              cmnd: item?.shipHang?.cmnd,
              noicap: item?.shipHang?.noicap,
              ngaygiaygioithieu: item?.shipHang?.ngaygiaygioithieu,
              xuathangkhotau: item?.shipHang?.xuathangkhotau,
              donvivanchuyen: item?.shipHang?.donvivanchuyen,
              donvinhanhang: item?.shipHang?.donvinhanhang,
              // data: item?.soanHang?.dataLogsPXKXN,
              data:
                !dataLogsPXKXN || dataLogsPXKXN.length === 0
                  ? item?.soanHang?.dataLogsPXk
                  : item?.shipHang?.dataLogsPXKXN,
              TenTaiKhoanThietBi: item?.soanHang?.tenTaiKhoanThietBi,
              TaiKhoanThietBi: item?.soanHang?.taiKhoanThietBiLogsPXK,
            },
          };
        });
        setData(mappedData);
        setTotal(total);
      })
      .finally(() => setLoading(false));
  }, [search, currentPage, refresh]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleSyncData = () => {
    if (!dataCheckbox?.length) {
      Swal.fire({
        icon: "warning",
        title: "Không có dữ liệu để đồng bộ",
        text: "Vui lòng chọn ít nhất một phiếu xuất kho.",
      });
      return;
    }
    const dataMap = new Map(data.map((d) => [d?.["10MPXK"], d]));

    const mappedData = dataCheckbox.map((item) => {
      const found = dataMap.get(item?.phieuxuatkhosaas);
      if (!found) return item;
      const oDetails = found?.soanHang?.o_data?.[0]?.details || [];
      const shipData = found?.dataShips?.data || [];

      const details = item?.data.map((da, index) => {
        // const matched = oDetails.find(
        //   (d) => d?.old_delivery_detail_id == da?.delivery_detail_id
        // );

        const matched = oDetails[index];
        return matched
          ? { ...da, delivery_detail_id: matched.delivery_detail_id }
          : da;
      });

      return {
        ...item,
        // ...found.dataShips,
        data: details,
      };
    });
    // console.log("PAYLOADDDD", mappedData);
    const payload = mappedData.map((item) => {
      const {
        _id,
        username,
        nguoinhan,
        TaiKhoanThietBi,
        TenTaiKhoanThietBi,
        biensoxetau,
        tenphuongtien,
        ngayxuat,
        data,
        ...props
      } = item;
      return {
        data: {
          ...props,
          // ngayxuat,
          data: data.map(({ soluongcanxuat, ...item }) => item),
          ngayxuat: ngayxuat
            ? moment(ngayxuat).utc().format("YYYY-MM-DDTHH:mm")
            : moment().format("YYYY-MM-DDTHH:mm"),
          donvivanchuyen: {
            label: item?.donvivanchuyen?.label,
            value: item?.donvivanchuyen?.value,
          },
          donvinhanhang: {
            label: item?.donvinhanhang?.label,
            value: item?.donvinhanhang?.value,
          },
          ngaygiaygioithieu: item?.ngaygiaygioithieu
            ? moment(item?.ngaygiaygioithieu).utc().format("DD/MM/yyyy")
            : "",
          ngaydangky: item?.ngaydangky
            ? moment(item?.ngaydangky).utc().format("DD/MM/yyyy")
            : "",
        },
        TaiKhoanThietBi: item?.TaiKhoanThietBi,
        TenTaiKhoanThietBi: item?.TenTaiKhoanThietBi,
      };
    });
    // console.log("PAYLOAD", payload);
    Swal.fire({
      title: "Bạn có muốn ship hàng?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Đồng bộ",
      cancelButtonText: "Huỷ",
    }).then((result) => {
      if (!result.isConfirmed) return;
      Swal.fire({
        title: "Đang đồng bộ dữ liệu...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });
      fetch(proxy() + `/api/SyncERP/PhieuXuatKhoConfirm`, {
        method: "POST",
        headers: { Authorization: token, "content-type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then((r) => r.json())
        .then(({ success, o_message: message }) => {
          Swal.fire({
            icon: success ? "success" : "error",
            title: success ? lang["success"] : lang["error"],
            text: message ? `ERP phản hồi: ${message}` : "",
            showConfirmButton: !success,
            timer: success && 1000,
          });
          if (success) {
            setDataCheckbox([]);
            setRefresh((x) => x + 1);
          }
        });
      // .finally(() => setRefresh((x) => x + 1));
    });
  };
  // console.log("DHDHDHDHD", dataCheckbox);
  return (
    <div className="container-fluid">
      <div className="row" style={{ margin: "5px -15px" }}>
        <div className="col-md-12">
          <div className="white_shd full">
            <div className="tabbar padding_infor_info_p-d-5">
              <div
                className="d-flex align-items-center page-title position-relative mb-0"
                style={{ padding: "8px 0px" }}
              >
                <span style={{ fontSize: 18, textTransform: "uppercase" }}>
                  Ship hàng phiếu xuất kho
                </span>
                <div className="ml-auto d-flex align-items-center">
                  <img
                    className="icon-add mr-2 pointer"
                    src="/images/sync.webp"
                    alt="#"
                    onClick={handleSyncData}
                    width={27}
                    height={27}
                  />
                  <FontAwesomeIcon
                    icon={faRetweet}
                    className="icon-add pointer"
                    fontSize={2}
                    style={{ color: "rgb(224, 118, 42)" }}
                    onClick={() => {
                      setRefresh((x) => x + 1);
                      setCurrentPage(1);
                      setDataCheckbox([]);
                      setSearchDraft();
                      setSearch();
                    }}
                  />
                </div>
              </div>

              <hr
                style={{ border: "1px solid #ddd", margin: "0px -11px 5px" }}
              />

              <div className="table-display d-flex">
                <ShipTable
                  key={refresh}
                  headers={headers}
                  data={data}
                  loading={loading}
                  lang={lang}
                  indexOfFirstData={indexOfFirstData}
                  dataCheckbox={dataCheckbox}
                  onToggleCheck={(checked, item) => {
                    const find = data.find((d) => d?._id === item?._id);

                    setDataCheckbox((prev) =>
                      checked
                        ? [...prev, find?.dataShips]
                        : prev.filter(({ _id }) => _id !== find?._id)
                    );
                  }}
                  onSearchChange={(patch) => {
                    setSearchDraft((prev) => ({ ...prev, ...patch }));
                  }}
                  onOpenDetail={(item) =>
                    navigate(`/PhieuXuatKho/${item?.["10MPXK"]}`)
                  }
                  onOpenEdit={(item) => setSelectedForEdit(item)}
                  onOpenShip={(item) => setSelectedForShip(item)}
                />

                <Pagination
                  total={total}
                  itemsPerPage={dataPerPage}
                  currentPage={currentPage}
                  paginate={paginate}
                  lang={lang}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <EditModal
        id="EditModal"
        lang={lang}
        proxy={proxy}
        token={token}
        item={selectedForEdit}
        onDone={() => {
          setRefresh((x) => x + 1);
          setDataCheckbox([]);
        }}
        setData={setData}
      />
      <ShipModal
        id="ShipModal"
        lang={lang}
        proxy={proxy}
        token={token}
        item={selectedForShip}
        onDone={() => {
          setDataCheckbox([]);
          setRefresh((x) => x + 1);
        }}
        setData={setData}
      />
    </div>
  );
}
